import { useAuth0 } from '@auth0/auth0-react';
import {
  SomaButton,
  SomaCard,
  SomaCardContent,
  SomaCardHeader,
  SomaIcon,
} from '@soma/react';
import React from 'react';

import xpIncLogo from '../../assets/logo-xp-inc.png';

import * as S from './style';

const Login = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <S.Content>
      <div className="card-content">
        <SomaCard clickable={false}>
          <SomaCardHeader>
            <img alt="XP Inc Logo" src={xpIncLogo} />
          </SomaCardHeader>
          <SomaCardContent>
            <SomaButton
              variant="ghost"
              onSomaClick={loginWithRedirect}
              ariaLabel="Faça seu login"
              icon="lock"
            >
              Faça seu login
              <SomaIcon size="md" icon="chevron-right" />
            </SomaButton>
          </SomaCardContent>
        </SomaCard>
      </div>
    </S.Content>
  );
};

export default Login;
